
import { defineComponent, inject, ref } from 'vue'
import FavoriteButton from '@/components/Form/FavoriteButton.vue'
import ModeButton from '@/components/Page/ModeButton.vue'

export default defineComponent({
  name: 'EventFloatingButtons',
  components: {
    FavoriteButton,
    ModeButton
  },
  setup() {
    return {}
  }
})
